const Section = ({ num, title, children }: { num: string; title: string; children: React.ReactNode }) => (
  <div className="mb-9">
    <h2 className="mb-3 border-b border-white/[0.07] pb-2 text-base font-bold text-white">
      {num}. {title}
    </h2>
    {children}
  </div>
);

const Sub = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div className="mb-4">
    <h3 className="mb-2 text-sm font-semibold text-slate-200">{title}</h3>
    {children}
  </div>
);

const T = ({ children }: { children: React.ReactNode }) => (
  <p className="mb-2 text-sm leading-[1.7] text-ak-muted">{children}</p>
);

import PageMeta from '../components/PageMeta';

const DatenschutzPage = () => (
  <>
  <PageMeta title="Datenschutzerklärung" description="Datenschutzerklärung von AK TechSolutions – Alexander Krein." path="/datenschutz" noIndex />
  <section className="mx-auto max-w-[760px] px-8 py-[clamp(40px,7vw,72px)]">
    <h1 className="mb-2 text-[clamp(1.5rem,3vw,2rem)] font-bold text-white">Datenschutzerklärung</h1>
    <p className="mb-10 text-[13px] text-ak-dim">Stand: April 2026</p>

    <Section num="1" title="Verantwortlicher">
      <T>Alexander Krein – TechSolutions</T>
      <T>E-Mail: requests@aktechsolutions.de</T>
      <T>Telefon: +49 (0) 151 578 779 89</T>
    </Section>

    <Section num="2" title="Erhebung und Speicherung personenbezogener Daten">
      <Sub title="Beim Besuch der Website">
        <T>
          Beim Aufrufen unserer Website werden durch den Browser automatisch Informationen an unseren Server
          übermittelt. Diese Informationen werden temporär in sogenannten Server-Logfiles gespeichert:
          IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene URL, verwendeter Browser und Betriebssystem.
        </T>
        <T>
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DS-GVO (berechtigtes Interesse am sicheren Betrieb der Website).
          Die Daten werden nach spätestens 7 Tagen gelöscht.
        </T>
      </Sub>
    </Section>

    <Section num="3" title="Kontaktformular">
      <Sub title="Beschreibung und Umfang der Datenverarbeitung">
        <T>
          Wenn Sie das Kontaktformular nutzen, werden die von Ihnen angegebenen Daten (Name, E-Mail-Adresse,
          Nachricht) zur Bearbeitung Ihrer Anfrage verarbeitet und per E-Mail weitergeleitet.
        </T>
      </Sub>
      <Sub title="Rechtsgrundlage">
        <T>Rechtsgrundlage ist Art. 6 Abs. 1 lit. b) DS-GVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f) DS-GVO.</T>
      </Sub>
      <Sub title="Speicherdauer">
        <T>Die Daten werden gelöscht, sobald sie für den Zweck ihrer Erhebung nicht mehr erforderlich sind.</T>
      </Sub>
    </Section>

    <Section num="4" title="Ihre Rechte als betroffene Person">
      <T>Sie haben das Recht auf:</T>
      <ul className="mb-2 list-disc pl-5 text-sm leading-[1.9] text-ak-muted">
        <li>Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DS-GVO)</li>
        <li>Berichtigung unrichtiger Daten (Art. 16 DS-GVO)</li>
        <li>Löschung Ihrer Daten (Art. 17 DS-GVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DS-GVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DS-GVO)</li>
        <li>Widerspruch gegen die Verarbeitung (Art. 21 DS-GVO)</li>
      </ul>
      <T>
        Zur Ausübung Ihrer Rechte wenden Sie sich an: requests@aktechsolutions.de
      </T>
    </Section>

    <Section num="5" title="Beschwerderecht">
      <T>
        Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
        personenbezogenen Daten zu beschweren.
      </T>
    </Section>

    <Section num="6" title="Datensicherheit">
      <T>
        Diese Website überträgt Daten ausschließlich über gesicherte Verbindungen. Wir setzen technische und
        organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust oder unberechtigten
        Zugriff zu schützen.
      </T>
    </Section>

    <Section num="7" title="Keine Weitergabe an Dritte">
      <T>
        Personenbezogene Daten werden nicht an Dritte weitergegeben, verkauft oder vermietet, sofern keine
        gesetzliche Verpflichtung besteht oder Sie ausdrücklich eingewilligt haben.
      </T>
    </Section>

    <Section num="8" title="Änderungen dieser Datenschutzerklärung">
      <T>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen oder
        Änderungen des Dienstes anzupassen. Die jeweils aktuelle Version ist auf dieser Seite abrufbar.
      </T>
    </Section>

    <Section num="9" title="Haftpflichtsiegel der Exali AG">
      <Sub title="Beschreibung und Umfang der Datenverarbeitung">
        <T>
          Diese Seite nutzt eine Einbindung des Haftpflicht­siegels der Exali AG. Das grafische Element des
          Siegels wird von den Servern der Exali AG nachgeladen. Hierzu wird auf Grund der technischen
          Gestaltung des Internets Ihre IP-Adresse verarbeitet, um die Grafik an Ihren Browser zu übertragen.
        </T>
        <T>
          Wenn Sie dieses Siegel anklicken, verlassen Sie unsere Seite und werden auf die Server der Exali AG
          weitergeleitet.
        </T>
        <T>
          Mehr Informationen finden Sie in der{' '}
          <a
            href="https://www.exali.de/Ueber-exali/Rechtliches/Datenschutzerklaerung,100401.php#Verwendung/Einbindung%20des%20exali.de-Haftpflicht-Siegels"
            target="_blank"
            rel="noopener noreferrer"
            className="text-ak-sky no-underline"
          >
            Datenschutzerklärung von Exali
          </a>
          .
        </T>
      </Sub>
      <Sub title="Rechtsgrundlage">
        <T>
          Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f) DS-GVO (berechtigtes Interesse).
        </T>
      </Sub>
      <Sub title="Zweck der Datenverarbeitung">
        <T>
          Die Datenverarbeitung dient dem Zweck, den Nachweis der gesetzlich vorgegebenen Pflichtangaben zur
          Berufshaftpflicht nach § 2 Abs. 11 DL-InfoV optisch ansprechend zu erbringen.
        </T>
      </Sub>
      <Sub title="Berechtigtes Interesse">
        <T>
          Unser berechtigtes Interesse für die Datenverarbeitung ergibt sich aus dem Zweck, ein ansprechendes
          Onlineangebot zu bieten und unseren Informationspflichten in gestalterisch ansprechender Weise
          nachzukommen.
        </T>
      </Sub>
    </Section>
  </section>
  </>
);

export default DatenschutzPage;
